import ExtendableError from '../lib/ExtendableError';
import { ApiError } from './API';

export class OrderError extends ExtendableError {
}

export class InvalidOrderStateError extends OrderError {
    name = "InvalidOrderStateError";

    constructor () {
        super(`Invalid order state`);
    }
}

export class TooManyTicketsError extends OrderError {
    message = 'Cannot add more tickets to basket'
    name = 'TooManyTicketsError'
}

export class NotEnoughAvailabilityError extends OrderError {
    message = 'No availability for requested product.'
    name = 'NotEnoughAvailabilityError'
}

export class InteropError extends OrderError {
    message = 'This fare is not available for this train operator'
    name = 'InteropError'
}

export function throwCorrectOrderError (error) {
    if (error instanceof ApiError) {
        switch (true) {
            case error.hasCode(6002):
                throw new InvalidOrderStateError();
            case error.hasCode(7001):
                throw new TooManyTicketsError();
            case error.hasCode(12000):
                throw new NotEnoughAvailabilityError();
        }
    }

    throw error;
}



// WEBPACK FOOTER //
// ./src/errors/Order.js